var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.645,
    height: 16.199,
    viewBox: "0 0 12.645 16.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5960",
    "data-name": "Group 5960",
    transform: "translate(-14359.059 -19794.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5928",
    "data-name": "Path 5928",
    d: "M155.065,28A1.072,1.072,0,0,0,154,29.067V42.933A1.072,1.072,0,0,0,155.065,44h10.311a1.072,1.072,0,0,0,1.067-1.067V29.067A1.072,1.072,0,0,0,165.376,28Zm0,.711h10.311a.347.347,0,0,1,.356.356V42.933a.347.347,0,0,1-.356.356H155.065a.347.347,0,0,1-.356-.356V29.067a.347.347,0,0,1,.356-.356Zm1.422,2.133a.356.356,0,1,0,0,.711h7.467a.356.356,0,1,0,0-.711Zm0,3.2a.356.356,0,1,0,0,.711h7.467a.356.356,0,1,0,0-.711Zm0,3.2a.356.356,0,1,0,0,.711h7.467a.356.356,0,1,0,0-.711Zm0,3.2a.356.356,0,1,0,0,.711h4.978a.356.356,0,1,0,0-.711Z",
    transform: "translate(14205.16 19767)",
    stroke: "#333",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.1604415a4e5cd5c38033fc5f4e5ee3d8.svg";
export { ForwardRef as ReactComponent };